import { ofType } from "redux-observable";
import { forkJoin, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { FILE_PARTS_UPLOAD_REQUEST } from "../../../actions/types";
import { filePartsUploadAction } from "../../../actions";
export var filePartsUploadEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(FILE_PARTS_UPLOAD_REQUEST), mergeMap(function(param) {
        var payload = param.payload;
        var partUploadRequests = payload.partUploadRequests, key = payload.key;
        // forkJoin works like Promise.all()
        return forkJoin(partUploadRequests).pipe(mergeMap(function(response) {
            if (response.includes(false)) {
                return of(filePartsUploadAction.failure({
                    key: key
                }));
            }
            var eTags = [];
            response.forEach(function(res) {
                var _res_xhr_getResponseHeader;
                eTags.push((_res_xhr_getResponseHeader = res.xhr.getResponseHeader("ETag")) === null || _res_xhr_getResponseHeader === void 0 ? void 0 : _res_xhr_getResponseHeader.replaceAll('"', ""));
            });
            return of(filePartsUploadAction.success({
                eTags: eTags,
                key: key
            }));
        }));
    }));
};
export default filePartsUploadEpic;

//# sourceMappingURL=index.js.map